import { AxiosError } from 'axios';

import { getApiClient } from './api.base';
import { clearLoading, setLoading } from '@/services/utils/loading.service';
import { AccountPasswordChangeRequest } from '@/models/account-password-change-request.model';
import { getStoredToken } from '../session/account-store.service';

type Response = boolean & AxiosError;

export const changePasswordService = async (
  payload: AccountPasswordChangeRequest,
): Promise<Response> => {
  setLoading();
  try {
    const token = getStoredToken();
    const response = await getApiClient('auth', token ?? '').put(
      '/api/v1/account/change-password',
      payload,
    );
    clearLoading();
    return response.data as Response;
  } catch (errorResponse) {
    const error = errorResponse as Response;
    console.info(error);
    clearLoading();
    return error;
  }
};
